import { PillButton } from "../PillButton";

import { TPillowProps } from "./Pillow.type";


export default function Pillows({chosenPractices, handleDelete}: TPillowProps) {
  return (
    <div className="flex flex-column gap-3 flex-wrap">
      {chosenPractices.map((item: any, index: number) => {
        return (
          <PillButton
            key={item}
            text={item}
            onClick={() => handleDelete(item, index)}
          />
        );
      })}
    </div>
  );
};